<script lang="ts">
    import Logo from '~assets/icons/apple-music-classical-logo.svg';
    import { getI18n } from '~/stores/i18n';

    const i18n = getI18n();
    const canonicalUrl = '/';

    const onClickHandler = () => {};
</script>

<div data-testid="logo" class="logo">
    <!-- svelte-ignore a11y-no-interactive-element-to-noninteractive-role -->
    <!-- TODO: Find out what the label on the logo should be -->
    <a
        aria-label={$i18n.t('ASE.Web.MusicClassical.Title')}
        role="img"
        href={canonicalUrl}
        on:click={onClickHandler}
    >
        <Logo aria-hidden="true" />
    </a>

    <!-- rdar://93109020 (JMOTW: Remove "file a radar" link before launch) -->
    <!-- <Radar /> -->
</div>

<style lang="scss">
    .logo {
        @media (--sidebar-visible) {
            min-height: 55px;
            display: flex;
            justify-content: space-between;
            white-space: nowrap;
            padding-inline-start: 30px;
            padding-inline-end: 30px;
        }

        :global(.logo) {
            height: 14px;
            fill: var(--systemPrimary);
            width: 129px;

            @media (--sidebar-visible) {
                height: auto;
                width: 186px;
                max-width: 100%; // Prevent logo overflowing sidebar
            }
        }

        :global(.beta) {
            margin-top: 6px;
            margin-inline-start: 7px;

            @media (--range-sidebar-hidden-down) {
                margin-top: 1px;
                height: 12px;
                width: 28px;
                vertical-align: text-top;
                margin-inline-start: 5px;
            }
        }

        :global(.ant) {
            @media (--sidebar-visible) {
                justify-self: flex-end;
            }
        }
    }

    a {
        --linkHoverTextDecoration: none;
        position: relative;
        display: flex;
        z-index: var(--z-default);

        /* Make the hit area larger */
        &::before {
            $tap-area-offset-vertical: 12px;
            $tap-area-offset-horizontal: 15px;
            content: '';
            position: absolute;
            padding: $tap-area-offset-vertical $tap-area-offset-horizontal;
            inset: -$tap-area-offset-vertical (-$tap-area-offset-horizontal);
        }
    }
</style>
